// Local on purpose: the shared copy moved from @hellopearl/iso-voice-models to
// @hellopearl/cl-auth0, whose only entry point also loads React components.

/**
 * Decodes the payload (second segment) of a JWT without verifying the signature.
 * Safe for extracting claims from an already-authenticated token.
 *
 * @param token — A three-part dot-separated JWT string
 */
export function decodeJwtPayload(token: string): Record<string, unknown> {
  const parts = token.split('.');
  if (parts.length !== 3) throw new Error('Invalid JWT: expected 3 segments');
  const base64Url = parts[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const padded = base64 + '='.repeat((4 - (base64.length % 4)) % 4);
  const json = atob(padded);
  return JSON.parse(json);
}

/** Custom-claim key used by the Pearl Auth0 tenant for the org identifier. */
export const PEARL_ORG_CLAIM = 'https://hellopearl.com/organization';

/** Extracts the Pearl organization ID from a decoded JWT payload. */
export function extractOrganizationId(
  payload: Record<string, unknown>,
): string | null {
  const value = payload[PEARL_ORG_CLAIM];
  return typeof value === 'string' && value ? value : null;
}

// Legacy alias used by tests and demo shim
export { PEARL_ORG_CLAIM as ORG_CLAIM };
